import { PaymentMethodWithCashlessAndBonusLabelTranslationKeys } from "#i18n/translations/pt-BR/components/payment-method-with-cashless-and-bonus";

export const PAYMENT_METHOD_WITH_CASHLESS_AND_BONUS_LABEL_EN_US: PaymentMethodWithCashlessAndBonusLabelTranslationKeys = {
	ZigPosCredit: "ZigPos Credit",
	ZigPosCreditInInstallments: "ZigPos Credit in Installments",
	ZigPosDebit: "ZigPos Debit",
	CreditCard: "Credit Card",
	DebitCard: "Debit Card",
	Cash: "Cash",
	App: "App",
	Voucher: "Voucher",
	Anticipated: "Anticipated",
	Pix: "Pix",
	Cashless: "Cashless",
	IntegratedFoodVoucher: "Food Voucher",
	MBWay: "MBWay",
	Bonus: "Bonus",
	MinimumConsumption: "Minimum Consumption",
	Ifood: "Ifood",
	DigitalCashless: "Cashless digital",
	Online: "Online",
	DeliveryOnline: "Delivery Online",
};
